import { render, staticRenderFns } from "./nueva-medicina-ocupacional.vue?vue&type=template&id=605bfb92&"
import script from "./nueva-medicina-ocupacional.vue?vue&type=script&lang=js&"
export * from "./nueva-medicina-ocupacional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports